export default "__VITE_ASSET__Dgn02JqR__"